<style>

  .dateColumn {
    /*font-weight: bold !important;*/
    min-width: 100px;
  }

  .anomaly {
    color: lightgrey;
  }

</style>

<template>

  <v-container fluid>

    <v-card>

      <!--<pre>{{sensorVariable}}</pre>-->
      <!--<pre>{{data}}</pre>-->

      <h2 class="text-xs-center my-3">{{label}}</h2>

      <v-data-table
        :headers="headers"
        :items="data"
        hide-actions
        must-sort
        :custom-sort="dataSort"
      >

        <!--
        :style="{ color: props.item[header.value].anomaly ? 'red' : 'auto' }"
        -->
        <template slot="items" slot-scope="props">
          <td v-for="header in headers"
              :class="{ anomaly: props.item[header.value].anomaly, dateColumn: header.value === 'date' }"
              v-if="props.item[header.value]">
            {{ props.item[header.value].value }}
          </td>
        </template>

      </v-data-table>

    </v-card>

  </v-container>

</template>

<script>
  import _ from 'lodash';
  import { DateTime } from 'luxon';

  export default {

    name: 'SensorVariableTable',

    data() {
      return {
        headers: [],
        data: [],
      };
    },

    mounted() {
      this.buildtable();
    },

    methods: {

      dataSort(items, search, desc) {
        if (search === 'date') {
          console.log('filtering by date', desc);
          return _.orderBy(items, ['date_time'], [desc ? 'desc' : 'asc']);
        } else if (search) {
          console.log('filtering by', search, desc);
          return _.orderBy(items, [search], [desc ? 'desc' : 'asc']);
        }
        return items;
      },

      buildtable() {
        if (this.sensorVariable) {
          // Build headers for Vuetify data table using stations in current data
          this.headers = this.sensorVariable.stations.map(station => ({
            text: station.stationId,
            value: station.stationId,
            align: 'left',
            sortable: true,
          }));

          // Insert a header for date/time regardless of station headers
          this.headers.unshift({
            text: 'Date/Time',
            value: 'date',
            align: 'left',
            sortable: true,
            width: 200,
          });

          const allData = [];

          // Iterate through each station, and for each station each data value
          // and push the data into a new array.
          this.sensorVariable.stations.forEach((station) => {
            station.tableData.forEach((data) => {
              const dateTime = DateTime.fromJSDate(data.dateTime);
              // Only keep values at the top of the hour (with no minutes)
              if (dateTime.minute === 0) {
                allData.push(data);
              }
            });
          });

          // Organize the array by date so each date grouping can be used to build a single object with
          // all stations for each date, rather than a separate record for each date and station.
          const groupedByDate = _.groupBy(allData, 'dateTime');

          // Get the observation values for each date group, and map them to a new object
          const d = _.values(groupedByDate).map((observations) => {
            // The DateTime value for this row.
            const dateTime = DateTime.fromJSDate(observations[0].dateTime);

            // An object contained the resulting station values
            const row = {
              date_time: dateTime.toISO(),
              date: { value: dateTime.toLocaleString(DateTime.DATETIME_SHORT) },
            };

            // Add the value for each station to the master object.
            observations.forEach((obs) => {
              row[obs.id] = {
                value: obs.value,
                anomaly: obs.anomaly,
              };
            });

            // Return the master object, which is used in the Vuetify data table
            return row;
          });

          // Sort the data by the date/time for display in the table
          this.data = _.orderBy(d, ['date_time']);
        }
      },

    },

    watch: {

      sensorVariable() {
        this.buildtable();
      },

    },

    computed: {

      sensorVariable() {
        return this.$store.state.sensorVariable.current;
      },

      label() {
        return this.sensorVariable ? this.sensorVariable.label : 'Not Available';
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/components/SensorVariable/Table.vue